import { isDefined } from '@sgme/fp';
import { v4 } from 'uuid';

import {
  DEFAULT_HEDGE_TYPE,
  DEFAULT_MARGIN_TYPE,
  DEFAULT_PRICE_TYPE,
  DEFAULT_SOLVING_TYPE,
  type FlexiForwardProperties,
  type FxFlexiForward,
} from '@/store/flexi-forward/state.ts';

export function generateFlexiForwardTile(currencyPair?: string, clientId?: number): FxFlexiForward {
  const [currency1, currency2] = currencyPair?.split('/') ?? [undefined, undefined];

  return {
    type: 'FxFlexiForward',
    properties: {
      currencyPair,
      currency1,
      currency2,
      clientsWay: 'Buy',
      deltaHedgeCurrencyIndex: 1,
      hedgeType: DEFAULT_HEDGE_TYPE,
      marginType: DEFAULT_MARGIN_TYPE,
      mifid: { records: [] },
      notionalCurrencyIndex: 1,
      premiumType: DEFAULT_PRICE_TYPE,
      premiumWay: 'Bid',
      priceCurrencyIndex: 1,
      rfs: { status: 'CANCELLED' },
      rfsVersion: 0,
      solvingType: DEFAULT_SOLVING_TYPE,
      upfrontCurrency: currency1,
    },
    tradeCapture: {
      sessionId: v4(),
      status: 'INITIALIZED',
      version: -1,
    },
    clientId,
  };
}

export function generateEmptyFlexiForwardTile(
  tileId: string,
  props?: FlexiForwardProperties,
  clientId?: number,
): FxFlexiForward {
  const [currency1, currency2] =
    isDefined(props) && isDefined(props.currencyPair) ? props.currencyPair.split('/') : [undefined, undefined];

  return {
    type: 'FxFlexiForward',
    properties: {
      tileId,
      currencyPair: '',
      currency1,
      currency2,
      clientsWay: 'Buy',
      deltaHedgeCurrencyIndex: 1,
      hedgeType: DEFAULT_HEDGE_TYPE,
      marginType: DEFAULT_MARGIN_TYPE,
      mifid: { records: [] },
      notionalCurrencyIndex: 1,
      premiumType: DEFAULT_PRICE_TYPE,
      premiumWay: 'Bid',
      priceCurrencyIndex: 1,
      rfs: { status: 'CANCELLED' },
      rfsVersion: 0,
      solvingType: DEFAULT_SOLVING_TYPE,
      upfrontCurrency: currency1,
      ...props,
    },
    tradeCapture: {
      sessionId: v4(),
      status: 'INITIALIZED',
      version: -1,
    },
    clientId,
  };
}
